module.exports = __webpack_public_path__ + "static/media/TiacWebLogo.c9fbf079.png";